export const UCFirst = (label) => {
    let name;
    if (!label) name = label;
    else name = label[0].toUpperCase() + label.slice(1);
    return name
}

